/*
 * @Author: zhenhui.duan
 * @Date: 2024-06-25 14:29:38
 * @Description:
 */
import utils from '@common/utils';

import './index.less';
import './saleCard.less';

// 扫码下载
const isDownloadApp = window.location.href.includes('from=qrcode-okj-site');

if (isDownloadApp) {
  const isAppleDevice = /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent);
  let forwardUrl =
    'https://play.google.com/store/apps/details?id=com.okinc.okcoin.jp';
  if (isAppleDevice) {
    forwardUrl = 'https://itunes.apple.com/app/id1614786640';
  }
  window.location.assign(forwardUrl);
}

function handleScroll() {
  const scrollTop = sessionStorage.getItem('homeScrollTop') || 0;

  if (scrollTop) {
    document.documentElement.scrollTo({ top: scrollTop });
  }

  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem('homeScrollTop', document.documentElement.scrollTop);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // web homepage init event
  window.seoMonitor.act('web_home_page');

  handleScroll();

  if (utils.isLogin()) {
    import('./layout/login');
  } else {
    import('./layout/noLogin');
  }
});
